
/**
 * Validation Helper 
 * 
 * Note: requires alerts widget
 * Note: requires depthFirst.js function
 */
(function($){
	/**
	 * Validation Helper
	 * Attach to a input box and attach some rules to validate the field
	 */
	"use strict";
	
	$.widget('ui.validate', {
		/**
		 * Default Initial Options
		 */
		options: {
			fieldName: false, // String name of thsi field to use in errors, otherwise if false the associated "label" name will be used (if found) else "field"
			trim: true, // Trim the field value before checking
			showImmediately: false, // Should qtips should up immediately, or should they just highlight the field?
			rules: [],
			validateOnChange: true, // When the value of the field is changed, validate it (false will disable this)
			required: true, // Is this field optional or not?
			beforeCheck: null,	// function to run before this field is checked for validity, e.g. to reset error messages
			onInvalid: null,	// function to run when this field is found to be invalid, e.g. to show error messages
			highlight: false,
			requiredMsg: false,
			otherElementType: ['multiselect','selectBox'],
            displayElement: null // If set to a jquery object, will assign invalid classes and alerts to this element instead
		},
				
		_create: function(){	
			var self = this.element, // TODO: "self" would refer to the javascript object not the element, rename variable to something else
				options = this.options;
			this.self = this.element;
			
			// Add the class indicating this field has validation
			self.addClass('validat_d');
			
			// Bind the events
			this._bindChangeEvent();
			
			// Figure out the field name
			this.figureFieldName();

			if(this.element.is('.input-checkbox-multi, .input-radio')){
				var displayElement = this.element.parents('div.form-element-radio:first');
				if(displayElement.length === 0) {
					displayElement = this.element.parents('div.multicheckbox-group:first');
				}

				this.options.displayElement = displayElement.length ? displayElement : null;
			};

			self.data('validationRules', {});
			
			// Add any rules provided at initilization
			for(var i in options.rules){
				if(!options.rules[i]){
					continue;
				}
				this.addRule(options.rules[i].type, options.rules[i].options);
			}
		},
		
		// Private
		_fieldName: '',
		
		/**
		 * Binds the event
		 */
		_bindChangeEvent: function(){
			if(this.options.validateOnChange){
				this.self.bind('change.validate refresh.validate', function(){
					$(this).validate('validate');
				});
			}
			else{
				this.self.unbind('change.validate refresh.validate');	
			}
		},
		
		/**
		 * Will trigger a "validate" event bound to the form, passing in an option indicating if the validation was successful or not
		 */
		_triggerFormEvent: function(){
			var form = this.element.parents('form');
			if(form.length > 0){
				form.trigger('validate', [(form.find('.invalid-field').length === 0) ? true : false]);
			}
		},
				
		/**
		 * Get the (optionally trimmed) value of this element
		 */
		_getVal: function(){
			var value = this.element.val(),
				displayElm = this._getDisplayElement();

			if(this.element.is('input[type="checkbox"],input[type="radio"]') && displayElm.length) {
				value = '';
				$.each(displayElm.find('input:checked'), function(){
					value += $(this).val();
				});
			}
			return this.options.trim ? $.trim(value) : value;
		},

        _getDisplayElement: function()
        {
            if(this.options.displayElement && this.options.displayElement.length) {
                return this.options.displayElement;
            }

            return this.element;
        },
		
		/**
		 * Loop through the attached rules and execute them
		 */
		_execute: function(){
			var val = this._getVal();
			
			var beforeCheckF = $.isFunction(this.options.beforeCheck) ? this.options.beforeCheck : this._beforeCheck;
			beforeCheckF.call(this);
			
			this.element.removeClass('invalid-field valid-field empty-field');
			var isValid = true;
			var onInvalidF = $.isFunction(this.options.onInvalid) ? this.options.onInvalid : this._onInvalid,
				avatarElm = this._getAvatarElement();


			if(typeof avatarElm === 'object'){
				avatarElm.removeClass('invalid-field valid-field empty-field');
			}
			// Handle required first
			if(this.options.required){
				if(!validateRules.required.exec.call(this, val)){
					isValid = false;
					onInvalidF.call(this, this._parseMessage(this._getMessage(this.options.requiredMsg)), 'isrequired');
					this.element.addClass('invalid-field');
					if(this.options.highlight){
						this.element.effect('highlight', { color: 'red' });
					}

					if(typeof avatarElm === 'object'){
						avatarElm.addClass('invalid-field');
						if(this.options.highlight){
							avatarElm.effect('highlight', { color: 'red' });
						}
					}
					return false;
				}
			}
			
			var isEmpty = $.trim(val).length === 0;
			
			var rules = this.self.data('validationRules');
			for(var i in rules){
				if(rules.hasOwnProperty(i)){

					var rule = rules[i];
                    if(!rule || !rule.rule){
                        continue;
					}
					
					// Only run a rule on an empty field if the option says so, or if this is a custom validator 
					var isCustomValidator = true; 
					for(var i2 in validateRules){ 
						if(validateRules[i2] === rule.rule){
							isCustomValidator = false; 
						}
					} 
					if(!isCustomValidator && isEmpty && (rule.options === null || typeof rule.options === 'undefined' || typeof rule.options.noEmpty === 'undefined' || rule.options.noEmpty === false)){
						continue;
					}
					
					if(!rule.rule.exec.call(this, val, rule.options)){ 
						isValid = false; 
						onInvalidF.call(this, this._parseMessage(rule.rule.desc, $.extend(true, {}, rule.options)), i);                  
						if(this.options.highlight){
							this.element.effect('highlight', { color: 'red' }); 
						}

						if(typeof avatarElm === 'object'){
							avatarElm.addClass('invalid-field');
							if(this.options.highlight){
								avatarElm.effect('highlight', { color: 'red' });
							}
						}
					} 
				}
			}
			
			if(isValid && isEmpty){
				// Empty, carry on
				this.element.addClass('empty-field valid-field');
				return;
			}
			else {
				this.element.addClass(!isValid ? 'invalid-field' : (this.element.is('.empty-field') ? '' : 'valid-field'));
			}
						
			this._triggerFormEvent(); // TODO: why do this?
		},
		
		/**
		 * Parse a error message replacing any keys with their values
		 */
		_parseMessage: function(message, options){
			if(!options){
				options = {};
			}
			options.field = this._fieldName;
			for(var key in options){
				// show date input date format in message 
				if(key === 'dateFormat'){ 
					var date = new Date();
					message = message.replace('%' + key + '%',date.toString(options[key][0])); 
				} 
				message = message.replace('%' + key + '%', options[key]);
			}

			return message;
		},
		
		// Get an custome message passed in through the options.  
		_getMessage: function(message){
			if(message === false){
				return validateRules.required.desc;
			}
			else{
				return message;
			}
		},
		
		/**
		 * Reset all validator rules bind to element
		 */
		resetValidator: function()
		{	
			var beforeCheckF = $.isFunction(this.options.beforeCheck) ? this.options.beforeCheck : this._beforeCheck;
			beforeCheckF.call(this);
			
			this.element.removeClass('invalid-field valid-field empty-field');

			// Make sure to not remove value from radio and checkbox input
			if(this.element.is('input[type="radio"],input[type="checkbox"]')) {
				this.element.removeAttr('checked');
			} else {
				this.element.val('');
			}

//			var onInvalidF = $.isFunction(this.options.onInvalid) ? this.options.onInvalid : this._onInvalid;
		},
		// Public
		/**
		 * Add a rule to this element
		 * @var string type The rule to add (select from predefined list)
		 * @var object options An object of options that the selected rule requires (each requires something different)
		 */
		addRule: function(type, options){
			if(!validateRules[type]){
				return;
			}
			
			var rules = this.self.data('validationRules'),
				key = type.toLowerCase();
			rules[key] = {
				rule: validateRules[type],
				options: options
			};
			this.self.data('validationRules', rules);
			
			// Execute the rule's prepare option
			if($.isFunction(validateRules[type].prepare)){
				validateRules[type].prepare(this.element, options);
			}
			
			return key;
		},
		_getAvatarElement: function(){
			var elementTypes = this.options.otherElementType,
				otherElement = '';

			for(var i in elementTypes){
				if(elementTypes.hasOwnProperty(i)) {
					var $dataAttribute = this.element.data(elementTypes[i]);
					if (typeof $dataAttribute === 'object') {
						switch (elementTypes[i]) {
							case 'multiselect':
								otherElement = $dataAttribute.button;
								break;
							case 'selectBox':
							default:
								break;
						}
					}
				}
			}

			return otherElement;
		},
		/**
		 * Add a rule through chaining
		 * @param type
		 * @param options
		 * @returns {*}
		 */
		chainRule: function(type, options){
			this.addRule(type, options);

			return this;
		},
		
		/**
		 * Replace default error message with custom message
		 * @var string type The rule name existed in element
		 * @var string custDesc - Description use to override the default 
		 */
		customDesc: function(type, custDesc){
			var rules = this.self.data('validationRules'),
				key = type.toLowerCase();
			
			if(!rules[key]){
				return;
			}
			
			rules[key].rule.desc = custDesc;
			this.self.data('validationRules', rules);
			
			return key;
		},
		
		/**
		 * Add a custom rule to this element.
		 * @var string desc needs to be the error description. Any field inside the options variable can be used in the message, just use %fieldname%
		 * @var object options An object of options that the selected rule requires to run
		 * @var function func A function that will be executed when this field is validated. Returns true on valid or false on error
		 */
		addCustomRule: function(desc, options, func){
			var rules = this.self.data('validationRules'),
				customCount = this.self.data('validationRulesCount'),
				key = 'cust_';
			
			if(typeof customCount !== 'number'){
				customCount = 0; 
			}
			
			customCount++;
			key += customCount;
			
			rules[key] = {
				rule: {
					desc: desc,
					exec: func
				},
				options: options
			};
			this.self.data('validationRules', rules);
			this.self.data('validationRulesCount', customCount);
			
			return this.element;
		},
		
		/**
		 * Remove a rule based on their key
		 * This will not reset any failed validation
		 */
		removeRule: function(key){
			var rules = this.self.data('validationRules');
			
			if(rules.hasOwnProperty(key)){
				delete rules[key];
			}
			
			this.self.data('validationRules', rules);
		},
		
		/**
		 * Validate
		 */
		validate: function(returnResult){
			this._execute();
            if(typeof returnResult === 'boolean' && returnResult) {
                var invalid = this.self.is('.invalid-field');
                this.self.removeClass('valid-field invalid-field empty-field');
                return invalid;
            }
		},

        isValid: function() {
            return !this.validate(true);
        },

		/**
		 * Set the field name
		 */
		setFieldName: function(fieldName){
			if(typeof fieldName !== "string"){
				try{ console.error('Field name is not a string'); }catch(e){}
				return;
			}
			this._fieldName = fieldName;
		},
		
		/**
		 * Figure out the field name
		 */
		figureFieldName: function(){
			if(!this.options.fieldName){
				// Is there a label?
				if(this.element.is('[id]') && this._getDisplayElement().length === 0){
					if($('label[for="' + this.element.attr('id') + '"]').length === 1){
						this._fieldName = '<strong>' + $.trim($('label[for="' + this.element.attr('id') + '"]').html()) + ':</strong>';
					}
					else {
						this._fieldName = 'This field';
					}
				}
				else {
					this._fieldName = 'This field';
				}
			}
			else {
				this.setFieldName(this.options.fieldName);
			}
		},
		
		/**
		 * Remove all errors
		 * TODO: decouple from alerts widget
		 */
		_beforeCheck: function(){
			var allIds = this._getDisplayElement().alerts('getAllIds'),
				avatarElm = this._getAvatarElement();

			for(var i in allIds){
				var id = allIds[i];
				if(typeof id !== 'string'){
					continue;
				}
				if(id.substring(0, 9) === 'validate-'){
					this._getDisplayElement().alerts('remove', id);

					if(typeof avatarElm === 'object')
					{
						avatarElm.alerts('remove', id);
					}
				}
			}
		},
		
		/**
		 * Show an error
		 * TODO: decouple from alerts widget
		 */
		_onInvalid: function(validationMessage, validatorId){
			if(!this._getDisplayElement().hasClass('alert_d')){
				this._getDisplayElement().alerts();
			}
			this._getDisplayElement().alerts('add', 'error', {
				id: 'validate-'+validatorId,
				message: validationMessage
			}, this.options.showImmediately);

			var avatarElm 	= this._getAvatarElement();
			if(typeof avatarElm === 'object')
			{
				if(!avatarElm.hasClass('alert_d'))
				{
					avatarElm.alerts();
				}
				avatarElm.alerts('add', 'error', {
					id: 'validate-'+validatorId,
					message: validationMessage
				}, this.options.showImmediately);
			}
		}
	});
	
	/**
	 * An object built up of predefined validation rules
	 * Each rule has a error string and a function. The error string
	 */
	var validateRules = {
		/**
		 * Minimum Length
		 * Options: {
		 * min: 5 // number of characters length needed
		 * }
		 */
		min: {
			desc: '%field% needs to be at least %min% characters long',
			exec: function(value, options){
				return (value.length >= options.min);
			}
		},
		
		/**
		 * Maximum Length
		 * Options: {
		 * max: 5 // number of characters length needed
		 * }
		 */
		max: {
			desc: '%field% needs to be no longer than %max% characters long',
			exec: function(value, options){
				return (value.length <= options.max);
			},
			prepare: function(elm, options){
				elm.attr('maxlength', options.max);
			}
		},
		
		/**
		 * Minimum Value (number)
		 * Options: {
		 * min: 5 // lowest number allowed
		 * }
		 */
		minNum: {
			desc: '%field% cannot be lower than %min%',
			exec: function(value, options){
				return parseFloat(value) >= parseFloat(options.min);
			}
		},
		
		nonNegative: {
			desc: '%field% cannot be a negative number',
			exec: function(value){
				// comparison returns false if not a number, we consider it 
				//  valid if it is not a number 
				return !(value < 0); 
			}
		},
		
		/**
		 * Maximum Value (number)
		 * Options: {
		 * max: 5 // highest number allowed
		 * }
		 */
		maxNum: {
			desc: '%field% cannot be higher than %max%',
			exec: function(value, options){
				return value <= options.max;
			}
		},
		
		/**
		 * A basic string field
		 */
		text: {
			desc: '%field% can only contain letters, numbers and basic punctuation marks',
			exec: function(value, options){
				return $.trim(value) === '' ? true : XRegExp('^([0-9\\p{L}"%?/$!*@#:.,\'_=+\\s&;()[\\]{}()]|-(?!-))*$').test(value); 
				/*
				 * Regex description:
				 * 		^ 									Matches the start of the string
				 * 		 (									Capturing group start
				 * 		  [									Character set start
				 * 		   0-9								Numbers
				 * 		   \\p{L}							Unicode characters from the letter set
				 * 		   "%?/$!*@#:.,\'_=+\\s&;()[\\]{}()	Any of the characters you see there (except backslashes, and "\\s" is any whitespace)
				 * 		  ]									End character set
				 * 		  |									OR
				 * 		  -									Single dash
				 * 		  (?!-)								NOT followed by another single dash
				 * 		 )									End capturing group
				 * 		*									Any number of the previous caputuring group
				 * 		$									Matches the end of the string
				 */
			}
		},
		
		/**
		 * Require a whole number (eg, not 3.1 but 3)
		 */
		integer: {
			desc: '%field% must be a whole number',
			exec: function(value){
                if(value === undefined || value === null){
                    return true;
                }
				return value % 1 === 0;
			}
		},

        float: {
            desc: '%field% must be a number',
            exec: function(value, options) {
                if(options.hasOwnProperty('acceptEmpty') && options.acceptEmpty && (value === undefined || value === null)) {
                    return true;
                }
                return !isNaN(parseFloat(value));
            }
        },
		
		/**
		 * Requires any number
		 */
		numeric: {
			desc: '%field% must be a number',
			exec: function(value){
				if(value === undefined || value === null){
					return true;
				}				
				if(typeof value === 'number'){
					return true;
				}
				
				return $.trim(value) === '' ? true : !isNaN(value - 0);
			}
		},
		
		/**
		 * Email address
		 */
		email: {
			desc: '%field% must be an email address',
			exec: function(value){
                return $.trim(value) === '' ? true : /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/i.test(value); // http://www.regular-expressions.info/email.html
			}
		},
		
		/**
		 * Letters only
		 */
		alpha: {
			desc: '%field% can only contain letters',
			exec: function(value){
				return $.trim(value) === '' ? true : XRegExp('^([\\p{L}]+)$').test(value); 
			}
		},
		
		/**
		 * Letters/Numbers only
		 */
		alphanumeric: {
			desc: '%field% can only contain letters and numbers',
			exec: function(value){
				return $.trim(value) === '' ? true : XRegExp('^([0-9\\p{L}]+)$').test(value);
			}
		},
		
		phone: {
			desc: '%field% needs to be a valid phone number',
			exec: function(value){
				return $.trim(value) === '' ? true : /^([0-9-+ \(\)]+)$/.test(value);
			}
		},
						
		/**
		 * Require a specific character set
		 * Options: {
		 *		char_desc: 'letters', // Simple description of the characters required
		 *		chars: 'a-zA-Z' // Valid characters
		 * }
		 */
		chars: {
			desc: '%field% can only contain %char_desc%',
			exec: function(value, options){
				return $.trim(value) === '' ? true : new RegExp('^([' + options.chars + ']+)$').test(value);
			}
		},
		

		website: {
			desc: '%field% must be a valid web address. Make sure the http:// is included on the front',
			exec: function(value, options){
				return true;
			},
			prepare: function(elm, options){
				elm.on('change', function() {
					var website = $.trim($(this).val());	
					var address;			
						if(!RegExp('^https?://.*', 'i').test(website) && $(this).val().trim() !== ""){
							address = 'http://' + website;
						}else{
							address = website;
						}
						$(this).val(address);	
				});
			}
		},
		
		/**
		 * Must be parsable as a date
		 */
		date: {
			desc: '%field% must be a date (e.g. 1 Jan 2012)',
			exec: function(value){
				return Date.parse(value) !== null;
			}
		},
		
		/**
		 * Must be parsable as a date and in correct format 
		 */
		dateFormat: {
			desc: '%field% must have a valid date format (e.g. %dateFormat%)',
			exec: function(value, options){
				return Date.parseExact(value, options.dateFormat) !== null;
			}
		},
		
		/**
		 * A special case, call on a container of From-To fields, and pass in a couple functions
		 *  which return the from and to dates as the options.
		 * Options: {
		 *		from: function(){ return new Date(); }, 
		 *		to: function(){ return new Date(); }
		 * }
		 */
		chronological: {
			desc: 'Dates must be chronological',
			exec: function(value, options){
				if(!options || !options.from || !options.to){
					throw 'from and to options required';
				}
				if(!$.isFunction(options.from) || !$.isFunction(options.to)){
					throw 'from and to must be functions';
				}
				var from = options.from();
				var to = options.to();
				if(!from || !to){
					return true; // no dates, cannot compare
				}
				return from < to;
			}
		},
		
		/**
		 * See chronological
		 * TODO: code reuse
		 */
		chronologicalOrEqual: {
			desc: 'Dates must be chronological or the same',
			exec: function(value, options){
				if(!options || !options.from || !options.to){
					throw 'from and to options required';
				}
				if(!$.isFunction(options.from) || !$.isFunction(options.to)){
					throw 'from and to must be functions';
				}
				var from = options.from();
				var to = options.to();
				if(!from || !to){
					return true; // no dates, cannot compare
				}
				return from <= to;
			}
		},
		
		/**
		 * Match a specific regular expression
		 * Options: {
		 *		char_desc: 'letters and numbers', // Simple description of the characters required
		 *		regexp: '^alpha' // Full regexp minus the surrounding /
		 * }
		 */
		regexp: {
			desc: '%field% can only contain %char_desc%',
			exec: function(value, options){
				return $.trim(value) === '' ? true : new RegExp(options.regexp).test(value);
			}
		},
		
		/**
		 * This field is required (special case, don't add normally)
		 */
		required: {
			desc: '%field% is required',
			exec: function(value, options){
				if(this.element.is('select')){
					return value.length > 0;
				}else if(this.element.is('input, textarea')){
					return $.trim(value) !== '';
				}else{
					return true; // unknown element type, consider valid so other rules to run
				}
			}
		},
		
		/** 
		 * This field is required (placeholder value is acceptable) 
		 */ 
		 requiredWithPlaceholder: {
			 desc: '%field% is required',
			 exec: function(value, options){
				 if(this.element.is('select')){ 
					 return this.element.find('option:selected:enabled').size() > 0; 
				 }else if(this.element.is('input, textarea')){
					 return $.trim(value) !== '' || $.trim(this.element.attr('placeholder')) !== ''; 
				 }else{ 
					 return true; // unknown element type, consider valid so other rules to run 
				 } 
			 } 
		 },
		 
		 hexColour: {
			 desc: '%field% must be a validate hex colour code including preceeding "#". Example: #FF0000',
			 exec: function(value, options){
                 if(value.charAt(0) !== '#') {
                     value = '#' + value;
                 }
				 return /^#[a-fA-F0-9]{6}$/.test(value);
		 	}
		 },

		/**
		 * Fly buys card validation (required flybuys.validation.min.js)
		 */
		 flyBuys: {
			 desc: '%field% must be a valid fly buys card number',
			 exec: function(value) {
				 if(XRegExp('^[0-9 -]+$').test(value) === false) {
					 return false;
				 }
				 if(typeof FlyBuys !== 'undefined'){
					 return FlyBuys.valid(value);
				 }
				 // Return true if fly buys validation function not found
				 return true;
			 }
		 }
		
	};
	

	/**
	 * Call on a form to validate all field within it
	 * @return bool 
	 */
	$.fn.validateForm = function(elemSelector){
		var element = $(this);
		if(elemSelector === 'inline-edit'){
			element.find(elemSelector).validate('validate');
		}else{
			if(!elemSelector){
				elemSelector = '.validat_d';
			}
			// Make sure we excluded disabled field
			element.find(elemSelector + ':not(:disabled)').depthFirst().each(function(){
				$(this).validate('validate');
			});
		}
		
		// Return the number of valid fields
		var valid =  element.find(elemSelector).filter('.invalid-field:not(:disabled)').size() === 0;
		if(!valid){
			$('.invalid-field').each(function(){
				if($(this).parents('.crud-group.crud-hidden').length > 0){
					$(this).parents('.crud-group.crud-hidden').each(function(){
						$(this).find('.crud-title .crud-title-toggler').trigger('click');
					});
				}
			});
			var firstInvalid = $('.invalid-field:first');
			if($('body').scrollTop() > firstInvalid.offset().top - 50){
				$('body').animate({scrollTop: firstInvalid.offset().top - 50 }, 250); 
			}
			firstInvalid.alerts('show');
		}
		return valid;
		
		
	};
})(jQuery);
